const STORAGE_KEY = 'boxim-device-id'

export const getClientDeviceId = () => {
	let deviceId = localStorage.getItem(STORAGE_KEY)
	if (!deviceId) {
		deviceId = window.crypto && window.crypto.randomUUID
			? window.crypto.randomUUID()
			: `web-${Date.now()}-${Math.random().toString(16).slice(2)}`
		localStorage.setItem(STORAGE_KEY, deviceId)
	}
	return deviceId
}
